import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./colors.css";

function App() {
  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [severity, setSeverity] = useState("");
  const [description, setDescription] = useState("");
  const [youtubeLink, setYoutubeLink] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [licensePlate, setLicensePlate] = useState("");
  const [carDescription, setCarDescription] = useState("");
  const [crimeFilter, setCrimeFilter] = useState("");

  //"https://traffic-report-submissions.onrender.com"
  var serverURL = "https://traffic-report-submissions.onrender.com/saveFile";

  const handleSave = (e) => {
    e.preventDefault();
    fetch(serverURL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name,
        location,
        date,
        time,
        severity,
        description,
        youtubeLink,
        phoneNumber,
        licensePlate,
        carDescription,
        crimeFilter,
      }),
    })
      .then((response) => response.text())
      .then((data) => console.log(data))
      .catch((err) => console.error(err));
  };

  return (
    <div className="container-fluid min-vh-100 bg-dark text-light d-flex justify-content-center align-items-center">
      <div className="card bg-mid-dark text-light shadow-lg p-4" style={{ width: "100%", maxWidth: "600px" }}>
        <h2 className="text-center mb-4">Traffic Report Form</h2>
        <form onSubmit={handleSave}>
          <div className="mb-3">
            <label className="form-label">Name:</label>
            <input className="form-control" type="text" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="mb-3">
            <label className="form-label">Location:</label>
            <input className="form-control" type="text" value={location} onChange={(e) => setLocation(e.target.value)} />
          </div>
          <div className="mb-3">
            <label className="form-label">Date:</label>
            <input className="form-control" type="date" value={date} onChange={(e) => setDate(e.target.value)} />
          </div>
          <div className="mb-3">
            <label className="form-label">Time:</label>
            <input className="form-control" type="time" value={time} onChange={(e) => setTime(e.target.value)} />
          </div>
          <div className="mb-3">
            <label className="form-label">Severity:</label>
            <select className="form-select" value={severity} onChange={(e) => setSeverity(e.target.value)}>
              <option value="">Select Severity</option>
              <option value="High">High</option>
              <option value="Medium">Medium</option>
              <option value="Low">Low</option>
              <option value="I Don't Know">I Don't Know</option>
            </select>
          </div>
          <div className="mb-3">
            <label className="form-label">Description:</label>
            <textarea className="form-control" rows="3" value={description} onChange={(e) => setDescription(e.target.value)} />
          </div>
          <div className="mb-3">
            <label className="form-label">Dashcam YouTube Link:</label>
            <input className="form-control" type="url" value={youtubeLink} onChange={(e) => setYoutubeLink(e.target.value)} />
          </div>
          <div className="mb-3">
            <label className="form-label">Phone Number:</label>
            <input
              className="form-control"
              type="tel"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="123-456-7890"
              pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">License Plate Number:</label>
            <input className="form-control" type="text" value={licensePlate} onChange={(e) => setLicensePlate(e.target.value)} />
          </div>
          <div className="mb-3">
            <label className="form-label">Car Description:</label>
            <textarea className="form-control" rows="2" value={carDescription} onChange={(e) => setCarDescription(e.target.value)} />
          </div>
          <div className="mb-4">
            <label className="form-label">Traffic Crime:</label>
            <select className="form-select" value={crimeFilter} onChange={(e) => setCrimeFilter(e.target.value)}>
              <option value="">Select Traffic Crime</option>
              <option value="Speeding">Speeding</option>
              <option value="Running a Red Light">Running a Red Light</option>
              <option value="Illegal Parking">Illegal Parking</option>
              <option value="Reckless Driving">Reckless Driving</option>
              <option value="Driving Under Influence">Driving Under Influence</option>
              <option value="Hit and Run">Hit and Run</option>
              <option value="Other">Other</option>
            </select>
          </div>
          <button type="submit" className="btn btn-primary w-100">
            Submit Report 🚨
          </button>
        </form>
      </div>
    </div>
  );
}

export default App;
